<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="经销商" prop="tenantId">
        <div class="input_d">
          <a-input v-model="agentName" placeholder="请选择" disabled :maxLength="50" />
          <a-button type="primary" @click="$refs.publicForm.handleAdd(4, form.tenantId)" style="margin-left: 20px">
            选择
          </a-button>
          <a-input v-model="form.tenantId" placeholder="请选择" disabled :maxLength="50"  v-show="shows"/>
        </div>
      </a-form-model-item>
      <a-form-model-item label="套餐" prop="packageId">
        <div class="input_d">
          <a-input v-model="packageName" placeholder="请选择" disabled :maxLength="50" />
          <a-button type="primary" @click="$refs.publicForm.handleAdd(2, form.packageId)" style="margin-left: 20px">
            选择
          </a-button>
          <a-input v-model="form.packageId" placeholder="请选择" disabled :maxLength="50"  v-show="shows"/>

        </div>
      </a-form-model-item>
      <a-form-model-item label="选择类型" prop="chooseType">
        <a-radio-group v-model="form.chooseType">
          <a-radio-button :value="1"> 预购续费 </a-radio-button>
          <a-radio-button :value="0"> 普通 </a-radio-button>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="是否使用优惠券" prop="useCoupon">
        <a-radio-group v-model="form.useCoupon">
          <a-radio-button :value="1"> 是 </a-radio-button>
          <a-radio-button :value="0"> 否 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <template v-if="form.useCoupon">
        <a-form-model-item label="优惠券" prop="couponId" v-if="form.useCoupon == 1">
          <div class="input_d">
            <a-input v-model="couponName" placeholder="请选择" disabled :maxLength="50" />
            <a-button type="primary" @click="$refs.publicForm.handleAdd(3, form.couponId)" style="margin-left: 20px">
              选择
            </a-button>
            <a-input v-model="form.couponId" placeholder="请选择" disabled :maxLength="50" v-show="shows" />
          </div>
        </a-form-model-item>
      </template>
      <a-form-model-item label="支付渠道" prop="payMethod">
        <a-select
show-search
:allowClear="true"
v-model="form.payMethod"
placeholder="请选择"
          option-filter-prop="children"
:filter-option="filterOption"
disabled>
          <a-select-option v-for="d in payMethod" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付类型" prop="payType">
        <a-select
show-search
:allowClear="true"
v-model="form.payType"
placeholder="请选择"
option-filter-prop="children"
          :filter-option="filterOption"
disabled>
          <a-select-option v-for="d in payType" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <!-- <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
    <PublicForm ref="publicForm" @changeTao="changeTao" @changeYou="changeYou" @changeAgent="changeAgent"></PublicForm>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/VR/renewal'
import parameter from '@/mixins/parameter'
// import publicForm from '../../../VR/assignAgents/modules/publicForm.vue'
import PublicForm from '../../assignAgents/modules/publicForm.vue'

export default {
  name: 'CreateForm',
  mixins: [parameter],
  components: { PublicForm },
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      agentName: '',
      shows: false,
      name: '',
      // 表单参数
      form: {
        id: undefined,
        couponId: undefined,
        couponCode: undefined,
        payMethod: 0,
        payType: 'WECHAT',
        remark: undefined,
        useCoupon: 1,
        ids: [],
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      packageName: '',
      couponName: '',
      rules: {
        couponId: [{ required: true, message: '请选择优惠券', trigger: 'blur' }],
        tenantId: [{ required: true, message: '请选择经销商', trigger: 'blur' }],
        packageId: [{ required: true, message: '请选择套餐', trigger: 'blur' }],
        payMethod: [{ required: true, message: '请选择支付渠道', trigger: 'blur' }],
        payType: [{ required: true, message: '请选择支付类型', trigger: 'blur' }],

        devCode: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    // 点击套餐返回
    changeTao(e) {
      if (e && e.id) {
        this.packageName = e.packageName
        this.form.packageId = e.id
      } else {
        this.packageName = ''
        this.form.packageId = ''
      }
    },
    // 点击返回经销商
    changeAgent(e) {
      if (e && e.id) {
        this.agentName = e.name
        this.form.tenantId = e.tenantId
      } else {
        this.agentName = ''
        this.form.tenantId = ''
      }
    },
    // 点击优惠券返回
    changeYou(e) {
      if (e && e.id) {
        this.couponName = e.couponName
        this.form.couponId = e.id
      } else {
        this.couponName = ''
        this.form.couponId = ''
      }
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.agentName = ''
      this.packageName = ''
      this.couponName = ''
      this.form = {
        id: undefined,
        couponId: undefined,
        couponCode: undefined,
        payMethod: 0,
        payType: 'WECHAT',
        remark: undefined,
        useCoupon: 1,
        ids: [],
      }
    },
    /** 新增按钮操作 */
    handleAdd(id, type) {
      this.reset()
      if (type == 1) {
        this.formTitle = '批量续费'
        this.form.ids = id
      } else {
        this.form.ids = [id]
        this.formTitle = '续费'
      }
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 0 !important;
}

.input_d {
  display: flex;
  align-items: center;
}
</style>
